import { render, staticRenderFns } from "./insuranceRecord.vue?vue&type=template&id=99143252&"
import script from "./insuranceRecord.vue?vue&type=script&lang=js&"
export * from "./insuranceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports